import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import SelectUsers from 'react-select';
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const CreateAnggotaPokjaComp = (props) => {
  // console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  // const [idHeader, setidHeader] = useState('');
  const [idUser, setidUser] = useState('');
  const [isPic, setisPic] = useState('');

  const handleCreateAnggota = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      isPic: isPic,
      idUser: idUser?.value,
      idHeader: props?.pokja?.id,
    };

    // console.log(requestBody);
    // return false;
    axios({
      url: '/pokja-detail/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully created Anggota Pokja!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.messages}`,
          });
        }
      });
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="user" className="col-sm-6 col-form-label required">
          Anggota Kelompok Kerja
        </label>
        <div className="col-12">
          <SelectUsers
            id="user"
            value={idUser}
            onChange={setidUser}
            options={props.users}
            placeholder="Pilih Anggota"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="isPic" className="col-sm-12 col-form-label required">PIC Pokja</label>
        <div className="col-12">
          <select onChange={(e) => setisPic(e.target.value)} className='form-control' id='isPic' value={isPic}>
            <option value="">- Choose -</option>
            <option value="Ya">Ya</option>
            <option value="Tidak">Tidak</option>
          </select>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreateAnggota()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateAnggotaPokjaComp;
